import React, { useEffect } from "react";
import styled from "styled-components";
import AOS from "aos";
import "aos/dist/aos.css";
import { media } from "../Utils/media";
import portfolioTopBg from "../Assets/Images/portfolioTopBg.jpg";
import performanceBG from "../Assets/Images/performanceBG.png";
import useCountOnView from "../Components/useCountOnView";
import { fluidFont } from "../Utils/fontSize";

const Portfolio = () => {
  useEffect(() => {
    AOS.init({});
  }, []);

  const [count1, ref1] = useCountOnView(9999, 1000);
  const [count2, ref2] = useCountOnView(500, 1000);
  const [count3, ref3] = useCountOnView(1000, 1000);
  const [count4, ref4] = useCountOnView(200, 1000);

  return (
    <PageContainer>
      <PageWrapper>
        <SectionTop>
          <SectionTopTitleArea>
            <SectionTopTitleCopy data-aos="fade-right" data-aos-delay="200" data-aos-duration="1400">
              PORTFOLIO
            </SectionTopTitleCopy>
          </SectionTopTitleArea>
          <SectionTopBG />
        </SectionTop>
        <Section1Container>
          <Wrapper>
            <Section1TextArea>
              <Section1TopTitleCopy data-aos="fade-up" data-aos-delay="250" data-aos-duration="1400">
                우리가 만든 내일
              </Section1TopTitleCopy>
              <Section1TopMainCopy data-aos="fade-up" data-aos-delay="300" data-aos-duration="1400">
                <span style={{ fontWeight: "800" }}>'Creating Tomorrow, Today'</span>를<br />
                실현한 실제 증거들
              </Section1TopMainCopy>
            </Section1TextArea>
          </Wrapper>
        </Section1Container>
        <Section2Container>
          <Wrapper>
            <Section2TitleCopy data-aos="fade-up" data-aos-delay="300" data-aos-duration="1400">
              전체 성과 지표
            </Section2TitleCopy>
            <Section2ItemArea>
              <Section2Item>
                <PerformanceItem data-aos="fade-up" data-aos-delay="200" data-aos-duration="1400">
                  <img src={require("../Assets/Images/performanceIcon1.png")} alt="performanceIcon1" width="80px" height="auto" />
                  <PerformanceItemTitleCopy>총 콘텐츠 발행 수</PerformanceItemTitleCopy>
                  <PerformanceItemBodyCopy ref={ref1}>{count1}개</PerformanceItemBodyCopy>
                </PerformanceItem>
                <PerformanceItem data-aos="fade-up" data-aos-delay="200" data-aos-duration="1400">
                  <img src={require("../Assets/Images/performanceIcon2.png")} alt="performanceIcon2" width="80px" height="auto" />
                  <PerformanceItemTitleCopy>총 콘텐츠 발행 수</PerformanceItemTitleCopy>
                  <PerformanceItemBodyCopy ref={ref2}>{count2}개</PerformanceItemBodyCopy>
                </PerformanceItem>
                <PerformanceItem data-aos="fade-up" data-aos-delay="200" data-aos-duration="1400">
                  <img src={require("../Assets/Images/performanceIcon3.png")} alt="performanceIcon3" width="80px" height="auto" />
                  <PerformanceItemTitleCopy>총 콘텐츠 발행 수</PerformanceItemTitleCopy>
                  <PerformanceItemBodyCopy ref={ref3}>{count3}개</PerformanceItemBodyCopy>
                </PerformanceItem>
                <PerformanceItem data-aos="fade-up" data-aos-delay="200" data-aos-duration="1400">
                  <img src={require("../Assets/Images/performanceIcon4.png")} alt="performanceIcon4" width="80px" height="auto" />
                  <PerformanceItemTitleCopy>총 콘텐츠 발행 수</PerformanceItemTitleCopy>
                  <PerformanceItemBodyCopy ref={ref4}>{count4}개</PerformanceItemBodyCopy>
                </PerformanceItem>
              </Section2Item>
            </Section2ItemArea>
          </Wrapper>
        </Section2Container>
        <Section3Container>
          <Wrapper>
            <Section3TitleCopy data-aos="fade-up" data-aos-delay="300" data-aos-duration="1400">
              포토폴리오 사례
            </Section3TitleCopy>
            <Section3ItemArea data-aos="fade-up" data-aos-delay="300" data-aos-duration="1400">
              <Section3ItemContainer>
                <img src={require("../Assets/Images/portfolioSec3Item.png")} alt="portfolioSec3Item" width={"100%"} />
              </Section3ItemContainer>
              <Section3ItemContainer>
                <img src={require("../Assets/Images/portfolioSec3Item.png")} alt="portfolioSec3Item" width={"100%"} />
              </Section3ItemContainer>
              <Section3ItemContainer>
                <img src={require("../Assets/Images/portfolioSec3Item.png")} alt="portfolioSec3Item" width={"100%"} />
              </Section3ItemContainer>
              <Section3ItemContainer>
                <img src={require("../Assets/Images/portfolioSec3Item.png")} alt="portfolioSec3Item" width={"100%"} />
              </Section3ItemContainer>
              <Section3ItemContainer>
                <img src={require("../Assets/Images/portfolioSec3Item.png")} alt="portfolioSec3Item" width={"100%"} />
              </Section3ItemContainer>
              <Section3ItemContainer>
                <img src={require("../Assets/Images/portfolioSec3Item.png")} alt="portfolioSec3Item" width={"100%"} />
              </Section3ItemContainer>
            </Section3ItemArea>
          </Wrapper>
        </Section3Container>
      </PageWrapper>
    </PageContainer>
  );
};

const PageContainer = styled.div`
  display: block;
  background-color: #000000;
  overflow: hidden;
`;

const PageWrapper = styled.div`
  display: block;
  box-sizing: border-box;
`;

const SectionTop = styled.div`
  display: block;
  position: relative;
  box-sizing: border-box;
  ${media.web`
      margin-top: 240px;
  `}
  ${media.mobile`
      margin-top: 136px;
  `}
`;

const SectionTopTitleArea = styled.div`
  width: 100%;
  position: absolute;
  left: 0;
  top: 0;
  transform: translateY(-50%);
`;

const SectionTopTitleCopy = styled.div`
  width: 100%;
  max-width: 1470px;
  padding: 0 20px;
  margin: 0 auto;
  color: rgb(255, 255, 255);
  font-family: "Pretendard";
  font-style: normal;
  font-weight: 800;
  line-height: 110%;
  ${media.web`
      font-size: ${fluidFont(72, 100)};
  `}
  ${media.mobile`
      font-size: 42px;
  `}
`;

const SectionTopBG = styled.div`
  background-attachment: fixed;
  width: 100%;
  box-sizing: border-box;
  background: url(${portfolioTopBg}) no-repeat center / cover;
  ${media.web`
    height:500px;
  `};
  ${media.mobile`
    background-size: 200%;
    background-position: top 40% center;
    height:320px;
  `};
`;

const Section1Container = styled.div`
  display: block;
  overflow-x: hidden;
  box-sizing: border-box;
  ${media.web`
    padding: 200px 0 150px;
  `}
  ${media.mobile`
    padding: 80px 0 60px;
  `}
`;

const Wrapper = styled.div`
  display: block;
  box-sizing: border-box;
  width: 100%;
  margin: 0 auto;
`;

const Section1TextArea = styled.div`
  text-align: center;
  margin: 0;
`;

const Section1TopTitleCopy = styled.div`
  color: #3da7ff;
  font-family: "Pretendard";
  font-style: normal;
  font-weight: 700;
  line-height: 1.4;
  margin-bottom: 12px;
  ${media.web`
      font-size: ${fluidFont(16, 24)};
  `}
  ${media.mobile`
      font-size: 16px;
  `}
`;

const Section1TopMainCopy = styled.div`
  color: rgb(255, 255, 255);
  font-family: "Pretendard";
  font-style: normal;
  font-weight: 400;
  line-height: 1.35;
  ${media.web`
      font-size: ${fluidFont(32, 64)};
  `}
  ${media.mobile`
      font-size: 32px;
  `}
`;

const Section2Container = styled.div`
  display: block;
  overflow: hidden;
  box-sizing: border-box;
`;

const Section2TitleCopy = styled.div`
  color: rgb(255, 255, 255);
  font-family: "Pretendard";
  font-style: normal;
  text-align: left;
  font-weight: 700;
  line-height: 1.4;
  text-align: center;
  ${media.web`
      font-size: ${fluidFont(32, 48)};
      margin-bottom:80px;
  `}
  ${media.mobile`
      font-size: 24px;
      margin-bottom:40px;
  `}
`;

const Section2ItemArea = styled.div`
  display: flex;
  justify-content: center;
  background: url(${performanceBG}) no-repeat center top 78% / 100%;
  box-sizing: border-box;
  ${media.web`
    padding-bottom:224px;
  `}
  ${media.mobile`
    width: 100%;
    background-position: center bottom;
    padding: 0 20px 140px;
  `}
`;

const Section2Item = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);

  max-width: 900px;
  ${media.web`
    gap: 20px;
  `}
  ${media.mobile`
    width: 100%;
    gap: 14px;
  `}
`;

const PerformanceItem = styled.div`
  display: flex;
  flex-direction: column;
  border: solid 1px rgba(255, 255, 255, 0.2);
  backdrop-filter: blur(10px);
  background: linear-gradient(140deg, rgba(84, 79, 79, 0.1), rgba(84, 79, 79, 0.05));
  position: relative;
  overflow: hidden;
  box-sizing: border-box;
  transition: all 0.2s;
  ${media.web`
    width:43vw;
    max-width:440px;
    height:320px;
    border-radius: 20px;
    padding: 30px 40px 40px 30px;
  `}

  ${media.mobile`
  width:100%;
    border-radius: 5px;
    padding: 10px 15px 15px 10px;
  `}

  &:hover {
    background: linear-gradient(140deg, rgba(61, 167, 255, 0.4), rgba(61, 167, 255, 0.08));
  }
`;

const PerformanceItemTitleCopy = styled.div`
  color: #3da7ff;
  font-family: "Pretendard";
  font-style: normal;
  position: relative;
  z-index: 2;
  text-align: right;
  font-weight: 700;
  ${media.web`
    font-size: ${fluidFont(16, 20)};
    margin-top:40px;
  `}
  ${media.mobile`
    font-size: 14px;
    margin-top:20px;
  `}
`;

const PerformanceItemBodyCopy = styled.div`
  color: rgb(255, 255, 255);
  font-family: "Pretendard";
  font-style: normal;
  position: relative;
  z-index: 2;
  text-align: right;
  font-weight: 700;
  ${media.web`
    font-size: ${fluidFont(32, 58)};
    margin-top:24px;
  `}
  ${media.mobile`
    font-size: 26px;
    margin-top:12px;
  `}
`;

const Section3Container = styled.div`
  display: block;
  overflow: hidden;
  box-sizing: border-box;
  ${media.web`
    padding-bottom: 200px;
  `}
  ${media.mobile`
    padding: 80px 0;
  `}
`;

const Section3TitleCopy = styled.div`
  color: rgb(255, 255, 255);
  font-family: "Pretendard";
  font-style: normal;
  text-align: center;
  font-weight: 700;
  line-height: 1.4;
  ${media.web`
      font-size: ${fluidFont(32, 48)};
      margin-bottom:80px;
  `}
  ${media.mobile`
      font-size: 24px;
      margin-bottom:40px;
  `}
`;

const Section3ItemArea = styled.div`
  display: grid;

  ${media.web`
    grid-template-columns: repeat(4, 1fr);
    gap: 24px;
  `}
  ${media.mobile`
    grid-template-columns: repeat(2, 1fr);
    gap: 16px;
  `}
`;

const Section3ItemContainer = styled.div`
  overflow: hidden;
  ${media.web`
border-radius:20px;
  `}
  ${media.mobile`
border-radius:10px;
  `}
`;

export default Portfolio;
